import React from 'react'
import styled from 'styled-components'

const StyledStepCircle = styled.div`
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  ${props =>
    props.completed &&
    `
    animation: completeStep 0.6s ease-out;
  `}
  ${props =>
    props.active &&
    `
    animation: pulseActive 2s infinite;
    box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.2);
  `}
  
  @keyframes completeStep {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes pulseActive {
    0% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
    }
    70% {
      box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    }
  }
`

const StepCircle = ({ isCompleted, isActive, isSpecial, icon }) => {
  const classes = `w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-semibold text-xs sm:text-sm transition-all duration-300 ${
    isCompleted
      ? 'bg-green-500 text-white shadow-lg'
      : isActive && !isSpecial
      ? 'bg-green-500 text-white'
      : isSpecial
      ? 'bg-citrus-red text-white'
      : 'bg-slate-200 text-slate-400 border-2 border-slate-300'
  }`

  return (
    <StyledStepCircle
      completed={isCompleted}
      active={isActive && !isSpecial}
      className={classes}
    >
      {isCompleted ? (
        <i className="fas fa-check text-xs sm:text-sm"></i>
      ) : (
        <i className={`${icon} text-xs sm:text-sm`}></i>
      )}
    </StyledStepCircle>
  )
}

export default StepCircle
